// extracted by mini-css-extract-plugin
export var arrows = "_u-6";
export var decrementer = "_u-a";
export var disabled = "_u-4";
export var error = "_u-1";
export var hiddenText = "_u-b";
export var incrementer = "_u-9";
export var input = "_u-8";
export var inputWrapper = "_u-0";
export var leadingIcon = "_u-c";
export var readonly = "_u-3";
export var regular = "_u-7";
export var small = "_u-5";
export var warning = "_u-2";